import React from 'react';
import styles from './howhelp.module.css';
import basestyles from '../../styles/basestyles.module.css';

function Howhelp() {
    return (
      <div className={styles.background}>
        <div className={basestyles.maxWidth}>
          <div className={styles.heading}>
            <h1>
              How we Help Everyone Grow Together With Us
            </h1>
            <p>
              Adaya's aim is not just about making money but to help everyone grow together with us.
            </p>
            <p className={styles.para}>Here's how we help!</p>
                  </div>
                  <div className={styles.useflex}>
                    <div className={styles.box1}>
                      <img src="farmers.jpeg" alt="farmer-img" className={styles.farmer}/>
                      <h3>Farmers</h3>
                      <ui>
                        <li>Stop Decaying of fruits and vegetables</li>
                        <li>Get payment within a day</li>
                        <li>Sell without bargain</li>
                        <li>Easily gain more revenue</li>
                      </ui> 
                      </div>
                      <div className={styles.box2}>
                      <img src="retailers-min.jpeg" alt="retailer-img" className={styles.retailer}/>
            <h3>Retailers</h3>
            <ui>
              <li>Avoid transit damage</li>
              <li>Get high quality fresh produce</li>
              <li>Ease of order</li>
              <li>Save time and Cost</li>
            </ui>
                      </div>
                      <div className={styles.box3}>
                      <img src="consumers.jpeg" alt="consumer-img" className={styles.consumer}/>
            <h3>Consumers</h3>
            <ui>
              <li>Safe to eat chemical-free food</li>
              <li>Reasonable price</li>
              <li>Get delivered within 12 hours</li>
              <li>Fresh Taste</li>
            </ui>
                      </div>
                  </div>
          </div>
              
      </div>
    );
  }
  
  export default Howhelp;
  